export default {
  researcher: { can: ['anon:download'] },
  tester: { can: ['session:download'] },
  manager: {
    can: ['anon:download', 'users:edit', 'session:edit', 'session:merge', 'study:downloads'],
    inherits: ['tester'],
  },
  admin: { can: ['globalusers:admin', 'groups:edit'], inherits: ['manager'] },
};
